import { render } from "./GateOrder.vue?vue&type=template&id=281fbdea"
import script from "./GateOrder.vue?vue&type=script&lang=js"
export * from "./GateOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__